import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 20 20",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		stroke: "#262626",
		strokeLinecap: "round",
		strokeWidth: 1.5,
		children: [/* @__PURE__ */ _jsx("path", { d: "M4.167.833v13a2 2 0 0 0 2 2h13" }), /* @__PURE__ */ _jsx("path", { d: "M15.833 19.167v-13a2 2 0 0 0-2-2h-13" })]
	})]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20viewBox%3D%220%200%2020%2020%22%3E%3Cg%20stroke%3D%22%23262626%22%20stroke-linecap%3D%22round%22%20stroke-width%3D%221.5%22%3E%3Cpath%20d%3D%22M4.167.833v13a2%202%200%200%200%202%202h13%22%2F%3E%3Cpath%20d%3D%22M15.833%2019.167v-13a2%202%200%200%200-2-2h-13%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E";
